import { HELP_CLEAR, HELP_UPDATE } from '../mutationTypes';

const initState = {
  loading: true,
  inputMode: 0,
  pagination: { pageNum: 1, pageSize: 20, count: 0, loading: false, state: 2 },
  queryModels: {
    categoryId: '',
    content: '',
  },
  queryRules: {},
  categories: [],
  list: [],
  historys: [],
  userInfo: {},
};
const state = {
  ...JSON.parse(JSON.stringify(initState)),
};
const getters = {};
const mutations = {
  // 清除
  [HELP_CLEAR](states, newValue = initState) {
    const newState = JSON.parse(JSON.stringify(newValue));
    Object.assign(states, newState);
  },
  // 更新
  [HELP_UPDATE](states, newValue = initState) {
    const newState = JSON.parse(JSON.stringify(newValue));
    Object.assign(states, newState);
  },
};
const actions = {};

export default {
  state,
  getters,
  mutations,
  actions,
};
